import {FiLoader} from "react-icons/fi";

import {Button} from "@/components/button/Button.tsx";
import {Card} from "@/components/card/Card.tsx";
import {Divider} from "@/components/divider/Divider.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {NetworkRunTestResult} from "@/lib/types/network.ts";

import {NetworkRunTestResults} from "./NetworkRunTestResults.tsx";
import {RunState} from "./useNetworkRunTest.ts";

import styles from "./NetworkAnalysisRunTest.module.scss";

/**
 * Right-column "Run a Test" card shown on the Check Analysis page once a NETWORK
 * run test has been started. Mirrors the edit page's Run Test card, renders the
 * shared results UI, and offers a re-run button below the results.
 */
export const NetworkAnalysisRunTest = ({
  state,
  result,
  error,
  title,
  onRun,
  ready,
}: {
  state: RunState;
  result: NetworkRunTestResult | null;
  error: string | null;
  title: string;
  onRun: () => void;
  ready: boolean;
}) => {
  const running = state === "running";

  return (
    <Card className="p-0" variant="white">
      <div className={styles.cardTop}>
        <div className="pulseTextH3Bold">Run a Test</div>
        <div className="pulseTextBodySmall pulse-color-gray-600 mt-2">
          Validate your configuration by running a test.
        </div>
      </div>
      <Divider />
      <div className={styles.cardBody}>
        <NetworkRunTestResults state={state} result={result} error={error} title={title} />

        {/* Run/Re-run button — shown once a run has started; spins and is disabled
            while running (matching the analysis-page action-bar Run Test button). */}
        {(running || result || error) && (
          <Button variant="primary" size="large" onClick={onRun} disabled={running || !ready} className="w-100 mt-3">
            {running && <Icon icon={FiLoader} className="pulseSpin me-2" />}
            Run Test
          </Button>
        )}
      </div>
    </Card>
  );
};
